import { theme } from '@bessemercws/components/theme';
import styled from '@emotion/styled';

export const HeaderContainer = styled('div')`
  .ghost-header {
    height: 7.75rem;
  }

  @media screen and (max-width: ${theme.breakpoints.values.md}px) {
    .ghost-header {
      height: 4rem;
    }
  }
`;
